import React from 'react';
import PageLayout from '../../layout/PageLayout';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <PageLayout>
      <div className="rtc-cookie-container">
        <h1 className="page-title">Cookie Policy</h1>
        <p>
          Effective Date: <span className="policy-update-date">01-Apr-2026</span>
        </p>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">1. Introduction</h2>
          <p className="rtc-cookie-text">
            This Cookie Policy explains how RuhiTech Solutions ("we", "our", or
            "us") uses cookies and similar tracking technologies when you visit
            our website at ruhitech.com. It explains what these technologies are,
            why we use them, and your rights to control their use. By continuing
            to use our website, you consent to our use of cookies as described in
            this policy.
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">2. What Are Cookies?</h2>
          <p className="rtc-cookie-text">
            Cookies are small text files placed on your device (computer, tablet,
            or mobile) when you visit a website. They are widely used to make
            websites work more efficiently, remember your preferences, and provide
            information to website owners about how visitors use their site.
            Cookies can be "session cookies" (deleted when you close your browser)
            or "persistent cookies" (stored on your device for a set period or
            until you delete them).
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">3. Why We Use Cookies</h2>
          <p className="rtc-cookie-text">
            RuhiTech Solutions uses cookies to:
          </p>
          <ul className="rtc-cookie-text">
            <li>Ensure our website functions correctly and securely.</li>
            <li>Remember your preferences and settings for a better browsing experience.</li>
            <li>Understand how visitors navigate and interact with our website so we can improve it.</li>
            <li>Analyse traffic patterns and measure the performance of our website and marketing efforts.</li>
            <li>Deliver relevant content and service information based on your interests.</li>
          </ul>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">4. Types of Cookies We Use</h2>
          <p className="rtc-cookie-text">
            We use the following categories of cookies:
          </p>
          <ul className="rtc-cookie-text">
            <li>
              <strong>Strictly Necessary Cookies:</strong> These cookies are
              essential for the website to function and cannot be switched off.
              They are usually set in response to your actions such as filling in
              forms or setting preferences. Without these cookies, the services
              you have requested cannot be provided.
            </li>
            <li>
              <strong>Performance and Analytics Cookies:</strong> These cookies
              collect anonymous information about how visitors use our website —
              such as which pages are visited most often and whether visitors
              receive error messages. This data helps us improve how our website
              performs. We may use tools such as Google Analytics for this
              purpose.
            </li>
            <li>
              <strong>Functional Cookies:</strong> These cookies allow the
              website to remember choices you make (such as your language or
              region) and provide enhanced, more personalised features. They may
              be set by us or by third-party providers whose services we have
              added to our pages.
            </li>
            <li>
              <strong>Marketing and Targeting Cookies:</strong> These cookies
              may be set through our website by our advertising partners. They
              may be used to build a profile of your interests and show you
              relevant content or advertisements on other sites. They do not
              store directly personal information but are based on uniquely
              identifying your browser and device.
            </li>
          </ul>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">5. Third-Party Cookies</h2>
          <p className="rtc-cookie-text">
            Some cookies on our website are placed by third-party services that
            appear on our pages, including but not limited to Google Analytics,
            Google reCAPTCHA, and social media platforms. These third parties
            have their own privacy and cookie policies, and we recommend you
            review them. We do not control third-party cookies.
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">6. How to Manage Cookies</h2>
          <p className="rtc-cookie-text">
            You have the right to accept or reject cookies. You can manage your
            cookie preferences in the following ways:
          </p>
          <p className="rtc-cookie-text">
            <strong>Browser Settings:</strong> Most web browsers allow you to
            control cookies through their settings or preferences menu. You can
            set your browser to refuse all cookies, accept only certain cookies,
            or notify you when a cookie is being set. Please note that disabling
            cookies may affect the functionality of our website and limit your
            access to certain features.
          </p>
          <p className="rtc-cookie-text">
            <strong>Opt-Out Tools:</strong> For analytics and advertising
            cookies, you may use opt-out tools provided by services such as
            Google Analytics Opt-out Browser Add-on or the Network Advertising
            Initiative opt-out page.
          </p>
          <p className="rtc-cookie-text">
            Please be aware that restricting or blocking cookies may impact your
            experience on our website, and some features may not function as
            intended.
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">7. Data Collected via Cookies</h2>
          <p className="rtc-cookie-text">
            Any personal data collected through cookies (such as IP addresses or
            browsing behaviour) will be handled in accordance with our Privacy
            Policy. We do not use cookies to collect sensitive personal
            information.
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">8. Changes to This Cookie Policy</h2>
          <p className="rtc-cookie-text">
            RuhiTech Solutions reserves the right to update this Cookie Policy
            at any time to reflect changes in technology, legislation, or our
            business practices. When we update this policy, we will revise the
            effective date at the top of this page. We encourage you to review
            this policy periodically. Your continued use of our website after
            any changes constitutes your acceptance of the updated policy.
          </p>
        </section>

        <section className="rtc-cookie-section">
          <h2 className="rtc-cookie-heading">9. Contact Us</h2>
          <p className="rtc-cookie-text">
            If you have any questions or concerns about our use of cookies or
            this Cookie Policy, please contact us at:
            <br />
            <strong>RuhiTech Solutions</strong>
            <br />
            Email: <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>
            <br />
            Phone: +91 8220343006
            <br />
            Address: #140, 1st Floor, Plaza Center, No 129, G.N. Chettey Road,
            Chennai - 600006
          </p>
        </section>
      </div>
    </PageLayout>
  );
};

export default CookiePolicy;
